export const config = {
  AUTH0_DOMAIN_PROD: process.env.AUTH0_DOMAIN_PROD,
  AUTH0_CLIENT_ID_PROD: process.env.AUTH0_CLIENT_ID_PROD,
  AUTH0_CLIENT_AUDIENCE_PROD: process.env.AUTH0_CLIENT_AUDIENCE_PROD,
  AUTH0_DOMAIN_SBX: process.env.AUTH0_DOMAIN_SBX,
  AUTH0_CLIENT_ID_SBX: process.env.AUTH0_CLIENT_ID_SBX,
  AUTH0_CLIENT_AUDIENCE_SBX: process.env.AUTH0_CLIENT_AUDIENCE_SBX,
  AUTH0_DOMAIN_STG: process.env.AUTH0_DOMAIN_STG,
  AUTH0_CLIENT_ID_STG: process.env.AUTH0_CLIENT_ID_STG,
  AUTH0_CLIENT_AUDIENCE_STG: process.env.AUTH0_CLIENT_AUDIENCE_STG,
  AUTH0_DOMAIN_DEV: process.env.AUTH0_DOMAIN_DEV,
  AUTH0_CLIENT_ID_DEV: process.env.AUTH0_CLIENT_ID_DEV,
  AUTH0_CLIENT_AUDIENCE_DEV: process.env.AUTH0_CLIENT_AUDIENCE_DEV,
  AUTH0_DOMAIN_LOCAL: process.env.AUTH0_DOMAIN_LOCAL,
  AUTH0_CLIENT_ID_LOCAL: process.env.AUTH0_CLIENT_ID_LOCAL,
  AUTH0_CLIENT_AUDIENCE_LOCAL: process.env.AUTH0_CLIENT_AUDIENCE_LOCAL,
}
